import { styled } from "@mui/material/styles";
import { InfoOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import React from "react";

export default function EInfoToolTip({
  msg,
  iconSize,
  status,
  opacity,
  style,
  darkModeSupport,
  "data-testid": dataTestId,
  tooltipContentTestId
}) {
  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} enterTouchDelay={0} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 250,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));

  return (
    <HtmlTooltip title={msg} data-testid={tooltipContentTestId}>
      <IconButton
        aria-label={msg}
        size="small"
        style={{
          ...style,
          ...{
            mt: "-5px"
          }
        }}
        data-testid={dataTestId}
      >
        {/* <InfoOutlined
          color={"primary"}
          fontSize="small"
          style={{
            fontSize: iconSize,
            opacity: status === "noData" ? 0.2 : 1,
          }}
        /> */}
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-9-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 3a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0v-3z"
            fill="var(--font-heavy-default)"
            className={`${status === "noData" && "icon-fill-disabled"}`}
          />
        </svg>
      </IconButton>
    </HtmlTooltip>
  );
}
